import React, { useCallback } from 'react';
import styled from 'styled-components';
import Select from 'components/UI/Select';
import { Space } from 'styles/themeSpaces';
import { Text } from 'styles/themeColors';
import { GENERAL_CONSTANTS } from 'constants/general';

// Component key prefix for forcing re-render on disabled state change
const COMPONENT_KEY_PREFIX = 'vendor-select';

const VendorSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${Space.spHalf};
  width: 259px;
`;

const SelectLabel = styled.div`
  font-size: 14px;
  color: ${Text.primary};
  font-weight: 500;
`;

interface VendorSelectionDropdownProps {
  selectedVendorName: string;
  vendorOptions: Array<{ value: string; id: string }>;
  onVendorChange: (vendorName: string) => void;
  disabled?: boolean;
  isAdminView?: boolean;
}

/**
 * Vendor selection dropdown component
 *
 * Handles vendor selection with proper styling and event handling
 */
const VendorSelectionDropdown: React.FC<VendorSelectionDropdownProps> = ({
  selectedVendorName,
  vendorOptions,
  onVendorChange,
  disabled = false,
  isAdminView = false
}) => {
  const handleVendorChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const vendorName = event.target.value;
    onVendorChange(vendorName);
  }, [onVendorChange]);

  return (
    <VendorSelectContainer>
      <SelectLabel>{GENERAL_CONSTANTS.VENDOR}</SelectLabel>
      <Select
        id='top-vendor-selector'
        key={`${COMPONENT_KEY_PREFIX}-${disabled}`}
        value={isAdminView ? GENERAL_CONSTANTS.ALL : selectedVendorName}
        onChange={handleVendorChange}
        options={vendorOptions}
        width="100%"
        height="36px"
        noBorder={false}
        placeholder={GENERAL_CONSTANTS.SELECT_VENDOR}
        disabled={disabled}
      />
    </VendorSelectContainer>
  );
};

VendorSelectionDropdown.displayName = 'VendorSelectionDropdown';

export default VendorSelectionDropdown;